import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ErrorHandlingService } from '../../../../error-handling/error-handling.service';

@Component({
  selector: 'app-input-errors',
  templateUrl: './input-errors.component.html',
  styleUrls: ['./input-errors.component.scss']
})
export class InputErrorsComponent implements OnInit {
  @Input() control: AbstractControl | null | undefined;

  constructor(public errorHandlingService: ErrorHandlingService) {}

  ngOnInit(): void {}
}
